import { useFormContext } from 'react-hook-form';

import { TotemCheckbox } from 'components/TotemCheckbox';

import { SiteFragmentFragment } from 'data/__generated__';

type Metadata = Omit<SiteFragmentFragment['urbantzMetadata'], '__typename'>;

type FormValues = {
    urbantzMetadata: Metadata;
};

export const UrbantzMetadataForm = () => {
    const { setValue, watch } = useFormContext<FormValues>();
    const metadata = watch('urbantzMetadata');

    const METADATA_LABELS: Record<keyof Metadata, string> = {
        needsInventoryBoissons: 'Inventaire Boissons',
        needsInventoryNonAlimentaire: 'Inventaire Non Alimentaire',
        needsInventorySnack: 'Inventaire Snack',
        needsCleaningMachineNECTA: 'Nettoyage Machine NECTA',
        needsSmallExpiryDateInventory: 'Inventaire Petites DLC',
        needsPunctualExpiryDateInventory: 'Inventaire DLC Ponctuel',
        replaceCompleteInventoryByZeroInventory: 'Remplacer Inventaire Complet par Zéro',
    };

    const metadataKeys: {
        name: keyof Metadata;
        label: string;
        activeWeekdays: { evenWeek: boolean; oddWeek: boolean }[];
    }[] = [
        {
            name: 'needsInventoryBoissons',
            label: METADATA_LABELS.needsInventoryBoissons,
            activeWeekdays: metadata.needsInventoryBoissons,
        },
        {
            name: 'needsInventoryNonAlimentaire',
            label: METADATA_LABELS.needsInventoryNonAlimentaire,
            activeWeekdays: metadata.needsInventoryNonAlimentaire,
        },
        {
            name: 'needsInventorySnack',
            label: METADATA_LABELS.needsInventorySnack,
            activeWeekdays: metadata.needsInventorySnack,
        },
        {
            name: 'needsCleaningMachineNECTA',
            label: METADATA_LABELS.needsCleaningMachineNECTA,
            activeWeekdays: metadata.needsCleaningMachineNECTA,
        },
        {
            name: 'needsSmallExpiryDateInventory',
            label: METADATA_LABELS.needsSmallExpiryDateInventory,
            activeWeekdays: metadata.needsSmallExpiryDateInventory,
        },
        {
            name: 'needsPunctualExpiryDateInventory',
            label: METADATA_LABELS.needsPunctualExpiryDateInventory,
            activeWeekdays: metadata.needsPunctualExpiryDateInventory,
        },
        {
            name: 'replaceCompleteInventoryByZeroInventory',
            label: METADATA_LABELS.replaceCompleteInventoryByZeroInventory,
            activeWeekdays: metadata.replaceCompleteInventoryByZeroInventory,
        },
    ];

    function toggleDay({
        dayIndex,
        name,
        isEvenWeekCheckbox,
    }: {
        dayIndex: number;
        name: keyof Metadata;
        isEvenWeekCheckbox: boolean;
    }) {
        setValue('urbantzMetadata', {
            ...metadata,
            [name]: metadata[name].map((value: { evenWeek: boolean; oddWeek: boolean }, index: number) =>
                index === dayIndex
                    ? {
                          evenWeek: isEvenWeekCheckbox ? !value.evenWeek : value.evenWeek,
                          oddWeek: isEvenWeekCheckbox ? value.oddWeek : !value.oddWeek,
                      }
                    : value,
            ),
        });
    }

    return (
        <div>
            Séparation par semaines paires / semaines impaires
            <table className="w-full text-foreground">
                <thead>
                    <tr>
                        <th className="text-left">Nom</th>
                        <th>Lundi</th>
                        <th>Mardi</th>
                        <th>Mercredi</th>
                        <th>Jeudi</th>
                        <th>Vendredi</th>
                        <th>Samedi</th>
                        <th>Dimanche</th>
                    </tr>
                </thead>
                <tbody>
                    {metadataKeys.map((metadataKey) => {
                        const { name, label, activeWeekdays } = metadataKey;

                        return (
                            <tr key={name}>
                                <td>{label}</td>
                                {activeWeekdays.map((weekday, dayIndex) => {
                                    return (
                                        <td key={dayIndex} className="text-center">
                                            <TotemCheckbox
                                                checked={weekday.evenWeek}
                                                onChange={() => toggleDay({ dayIndex, name, isEvenWeekCheckbox: true })}
                                            />
                                            <TotemCheckbox
                                                checked={weekday.oddWeek}
                                                onChange={() =>
                                                    toggleDay({ dayIndex, name, isEvenWeekCheckbox: false })
                                                }
                                            />
                                        </td>
                                    );
                                })}
                                <td className="text-center">
                                    <TotemCheckbox disabled checked={false} onChange={() => {}} />
                                    <TotemCheckbox disabled checked={false} onChange={() => {}} />
                                </td>
                                <td className="text-center">
                                    <TotemCheckbox disabled checked={false} onChange={() => {}} />
                                    <TotemCheckbox disabled checked={false} onChange={() => {}} />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
